import PrimeVue from "primevue/config";
import Skeleton from "primevue/skeleton";
import type { App } from "vue";

export default {
  install: (app: App) => {
    app.use(PrimeVue, {
      unstyled: true,

      locale: {
        dayNamesMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
      },

      pt: {
        // Skeleton
        skeleton: {
          root: "p-skeleton",
          hooks: "p-skeleton__hooks"
        },

        // Listbox
        listbox: {
          root: "p-listbox",
          header: "p-listbox__header",
          pcFilterContainer: {
            root: "p-listbox__filter-container"
          },
          pcFilter: {
            root: "p-listbox__filter-input"
          },
          pcFilterIconContainer: {
            root: "p-listbox__filter-icon-container"
          },
          filterIcon: "p-listbox__filter-icon",
          listContainer: "p-listbox__wrapper",
          virtualScroller: "p-listbox__virtual-scroller",
          list: "p-listbox__list",
          optionGroup: "p-listbox__item-group",
          option: "p-listbox__item",
          optionCheckIcon: "p-listbox__item-check-icon",
          optionBlankIcon: "p-listbox__item-blank-icon",
          emptyMessage: "p-listbox__empty-message",
          hiddenFirstFocusableEl: "p-listbox__hidden-first-focusable-el",
          hiddenFilterResult: "p-listbox__hidden-filter-result",
          hiddenSelectedMessage: "p-listbox__hidden-selected-message",
          hiddenLastFocusableEl: "p-listbox__hidden-last-focusable-el"
        },

        multiselect: {
          root: "p-multiselect",
          labelContainer: "p-multiselect-label-container",
          label: "p-multiselect-label",
          clearIcon: "p-multiselect-clear-icon",
          chipItem: "p-multiselect-chip-item",
          pcChip: { root: "p-multiselect-chip" },
          dropdown: "p-multiselect-dropdown",
          loadingIcon: "p-multiselect-loading-icon",
          dropdownIcon: "p-multiselect-dropdown-icon",
          overlay: "p-multiselect-overlay",
          header: "p-multiselect-header",
          pcFilterContainer: { root: "p-multiselect-filter-container" },
          pcFilter: { root: "p-multiselect-filter" },
          list: "p-multiselect-list",
          option: "p-multiselect-option",
          pcOptionCheckbox: {
            root: "pc-option-checkbox"
          },
          hiddenInput: "p-multiselect__hidden-input"
        }
      }
    });

    app.component("PSkeleton", Skeleton);
  }
};
